<template>
  <b-modal
    id="Trigger-Assessment"
    :visible="showMultiTrigger"
    size="xl"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    @hidden="closeModal()"
  >
    <div class="cs-modal-header">
      <div class="d-flex align-items-center">
        <div>Trigger Multiple Assessment</div>
        <div class="tma-ftf-testtxt ml-4 mr-2">For Round (Assessment) :</div>
        <div class="tma-psy-testtxt">{{ process.name }}</div>
      </div>
      <img
        @click="closeModal()"
        class="rotate-on-hover"
        src="../../../assets/img/accessconnew/blueCross.svg"
        alt=""
      />
    </div>
    <div class="pl-3 pr-3">
      <div class="d-flex justify-content-between align-items-center w-100 py-3">
        <div class="exc-seacrh position-relative w-50">
          <span>
            <img
              class="search-pos"
              src="../../../assets/img/search-bar-icon.svg"
              alt=""
            />
          </span>
          <b-form-input
            class="search-input"
            type="search"
            v-model.trim="searchQuery"
            debounce="500"
            @update="checkAndGetData"
            placeholder="Search Candidate"
          ></b-form-input>
        </div>

        <div class="d-flex align-items-center">
          <div class="tp-bluetxt mr-4">
            Selected Candidates:&nbsp; {{ formattedSelectedLength }}
          </div>
          <!-- <div class="acs-addBtn-modal">
            <img
              class="mr-2 mb-1"
              src="../../../assets/img/accessconnew/whiteFilter.svg"
              alt
            />
            <span>Filter</span>
          </div> -->
          <div class="position-relative bluebtn">
            <b-button class="acs-addBtn" ref="filter-btn" @click="showFilter()"
              ><img
                class="mr-2"
                src="../../../assets/img/accessconnew/whiteFilter.svg"
                alt=""
              />
              <div
                class="mb-3"
                style="position: absolute; top: 1px; left: 38px"
                v-if="filtercount != 0"
              >
                <img src="../../../assets/panelist/fil_selected.svg" alt="" />
              </div>
              Filter</b-button
            >
            <div
              style="top: 35px; right: 0px"
              v-if="showfiltercard"
              class="acs-filter p-3"
              ref="filter-box"
              v-closable="{
                exclude: ['filter-btn', 'filter-box'],
                handler: 'hideFilterBox',
              }"
            >
              <b-row>
                <b-col>
                  <Sourcemulti
                    :label="'Source'"
                    :placeholder="'Select Source'"
                    :hideVendor="$route.name === 'VendorKanban'"
                    :vmodel="filterObject.filterSource"
                    :showThirdParty="showThirdParty"
                    @setValue="filterObject.filterSource = $event"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div
                    class="topDiv mt-3 aoeskl-field panellist-tags"
                    @click.stop=""
                  >
                    <label class="acs-input-head">Skills &nbsp;</label>
                    <b-form-tags
                      class="text-truncate filter-input-pan w-100"
                      id="input-1"
                      placeholder="Enter Skills"
                      v-model="filterObject.skillSets"
                      type="text"
                      invalid-tag-text="Duplicate tag(s)"
                      remove-on-delete
                    ></b-form-tags>
                    <!-- :tag-validator="tagValidatorskill" -->
                  </div>
                  <div class="hint-txt ml-3">Press "Enter" to add skills</div>
                </b-col>
              </b-row>

              <!-- Added by -->

              <div
                v-if="$route.name != 'VendorKanban'"
                class="previewfdbck-tabs mt-2"
              >
                <b-row>
                  <b-col>
                    <AddedByUsers
                      :placeholder="'Select'"
                      :label="'Added By'"
                      :vmodel="filterObject.createdByUserName"
                      @setValue="filterObject.createdByUserName = $event"
                    />
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col>
                  <div class="topDiv mt-3">
                    <label class="acs-input-head">No.of Trigger</label>
                    <b-form-input
                      type="number"
                      min="0"
                      v-model="filterObject.noOfTriggers"
                      class="teams-inputField"
                      placeholder="Enter no of triggers"
                    ></b-form-input>
                  </div>
                </b-col>
              </b-row>
              <div class="d-flex justify-content-between mt-4 bluebtn">
                <b-button class="acs-cancelBtn-filter" @click="cancelFilter()"
                  >Cancel</b-button
                >
                <div class="d-flex">
                  <b-button
                    :disabled="!disableApplyFilter"
                    @click="
                      !disableApplyFilter && filtercount == 0
                        ? ''
                        : filtercount == 0
                        ? clearfilter(false)
                        : clearfilter(true)
                    "
                    class="acs-cancelBtn-filter mr-3"
                    >Reset</b-button
                  >
                  <b-button
                    :disabled="!disableApplyFilter && filtercount == 0"
                    @click="applyFilterTest()"
                    class="acs-cancelBtn-filter"
                    >Apply</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kanban-exc-main-table">
        <b-overlay :show="LoaderStatus" rounded="sm" class="h-100">
          <div class="exc-table-head">
            <div class="common-single-checkbox pl-3" style="width: 5%">
              <b-form-checkbox
                v-model="allSelected"
                @change="selectAllCandidates"
              ></b-form-checkbox>
            </div>
            <div style="width: 7%">
              <span class="mr-2">Source</span>

              <template v-if="statusValue == 'source'">
                <img
                  v-if="sortByValue && filter"
                  class="pointer"
                  @click="(sortByValue = !sortByValue), checkAndGetData()"
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue && filter"
                  class="pointer"
                  @click="(sortByValue = !sortByValue), checkAndGetData()"
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="
                  (filter = true),
                    (statusValue = 'source'),
                    (sortByValue = true),
                    checkAndGetData()
                "
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 15%">
              <span class="mr-2">Candidate Name</span>
              <template v-if="statusValue == 'name'">
                <img
                  v-if="sortByValue && filter"
                  class="pointer"
                  @click="
                    (statusValue = 'name'),
                      (sortByValue = !sortByValue),
                      checkAndGetData()
                  "
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue && filter"
                  class="pointer"
                  @click="
                    (statusValue = 'name'),
                      (sortByValue = !sortByValue),
                      checkAndGetData()
                  "
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="
                  (filter = true),
                    (statusValue = 'name'),
                    (sortByValue = true),
                    checkAndGetData()
                "
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 15%">
              <span class="mr-2">Email</span>

              <template v-if="statusValue == 'email'">
                <img
                  v-if="sortByValue && filter"
                  class="pointer"
                  @click="
                    (statusValue = 'email'),
                      (sortByValue = !sortByValue),
                      checkAndGetData()
                  "
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue && filter"
                  class="pointer"
                  @click="
                    (statusValue = 'email'),
                      (sortByValue = !sortByValue),
                      checkAndGetData()
                  "
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="
                  (filter = true),
                    (statusValue = 'email'),
                    (sortByValue = !sortByValue),
                    checkAndGetData()
                "
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 10%">
              <span>Phone Number</span>
            </div>
            <div class="" style="width: 23%">
              <span>Skills</span>
            </div>
            <div style="width: 15%">
              <span class="mr-2">No.of Re-Trigger</span>
              <template v-if="statusValue == 'noOfAssessmentTriggers'">
                <img
                  v-if="sortByValue && filter"
                  class="pointer"
                  @click="
                    (statusValue = 'noOfAssessmentTriggers'),
                      (sortByValue = !sortByValue),
                      checkAndGetData()
                  "
                  src="../../../assets/img/accessconnew/ascSort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue && filter"
                  class="pointer"
                  @click="
                    (statusValue = 'noOfAssessmentTriggers'),
                      (sortByValue = !sortByValue),
                      checkAndGetData()
                  "
                  src="../../../assets/img/accessconnew/descSort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="
                  (filter = true),
                    (statusValue = 'noOfAssessmentTriggers'),
                    (sortByValue = !sortByValue),
                    checkAndGetData()
                "
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 10%">
              <span class="">Action</span>
            </div>
          </div>

          <div class="exc-table-body" v-if="candidates.length != 0">
            <div
              :style="
                candidatesSelected.includes(cand.candidateID) &&
                'background : #E1EEF7 !important'
              "
              class="
                kanban-exc-table-row
                mt-3
                d-flex
                justify-content-between
                align-items-center
                px-0
              "
              v-for="cand in candidates"
              :key="cand.candidateID"
            >
              <div class="kanban-tp-blueline"></div>
              <div
                style="width: 5%"
                class="d-flex justify-content-between align-items-center"
              >
                <div class="common-single-checkbox pl-3">
                  <b-form-checkbox
                    :disabled="
                      !candidatesSelected.includes(cand.candidateID) &&
                      candidatesSelected.length >= 20
                    "
                    :value="cand.candidateID"
                    v-model="candidatesSelected"
                    @change="deselect()"
                  >
                  </b-form-checkbox>
                </div>
              </div>
              <div class="" style="width: 7%">
                <img
                  v-if="
                    cand.source == null ||
                    convertToLowerCase(cand.source) == 'other'
                  "
                  src="../../../assets/img/talentpool/default.svg"
                  alt=""
                />
                <img
                  v-else-if="convertToLowerCase(cand.source) == 'linkedin'"
                  src="../../../assets/img/talentpool/linkdin.svg"
                  alt=""
                />
                <img
                  v-else-if="convertToLowerCase(cand.source) == 'monster'"
                  src="../../../assets/img/talentpool/monster.svg"
                  alt=""
                />
                <img
                  v-else-if="convertToLowerCase(cand.source) == 'naukri'"
                  src="../../../assets/img/talentpool/naukri.svg"
                  alt=""
                />
                <img
                  v-else-if="convertToLowerCase(cand.source) == 'indeed'"
                  src="../../../assets/img/talentpool/indeed.svg"
                  alt=""
                />
                <img
                  v-else-if="convertToLowerCase(cand.source) == 'seek'"
                  src="../../../assets/img/talentpool/seek.svg"
                  alt=""
                />
                <img
                  v-else-if="convertToLowerCase(cand.source) == 'vendor'"
                  src="../../../assets/img/talentpool/vendor.svg"
                  alt=""
                />
              </div>
              <div class="pr-2 text-truncate" style="width: 15%">
                {{ cand.name }}
              </div>
              <div class="pr-2 text-truncate" style="width: 15%">
                {{ cand.email }}
              </div>
              <div class="pr-2" style="width: 10%">{{ cand.phoneNumber }}</div>
              <div
                class="text-truncate pr-2"
                v-b-popover.hover.top="cand.skills.join(', ')"
                style="width: 23%"
              >
                {{ cand.skills.join(", ") }}
              </div>
              <div style="width: 15%">{{ cand.noOfAssessmentTriggers }}</div>
              <div style="width: 10%">
                <div class="">
                  <div class="d-flex justify-content-around">
                    <img
                      @click="$emit('view-candidate', cand)"
                      v-if="viewCandID != cand.candidateID"
                      src="../../../assets/img/accessconnew/blueEye.svg"
                      alt="/"
                      class="pointer mr-2"
                    />
                    <img
                      v-else
                      height="25"
                      width="25"
                      src="../../../assets/talentpool/notviewicon.svg"
                      alt=""
                      class="mr-2"
                    />
                    <img
                      @click="downloadResume(cand)"
                      class="pointer pr-3"
                      src="../../../assets/talentpool/download.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="exc-table-body" v-else id="top1">
            <div
              v-if="
                !LoaderStatus && candidates.length === 0 && searchQuery !== ''
              "
              class="
                d-flex
                justify-content-center
                align-items-center
                h-100
                flex-column
              "
            >
              <div>
                <img src="../../../assets/panelLog/searchnotfoundpan.svg" />
              </div>
              No matching results for&nbsp;
              <strong class="wordbreak"> "{{ searchQuery }}" </strong>
            </div>

            <div
              v-else-if="
                !LoaderStatus && candidates.length === 0 && searchQuery === ''
              "
              class="
                d-flex
                justify-content-center
                align-items-center
                h-100
                flex-column
              "
            >
              <div>
                <img src="../../../assets/panelLog/searchnotfoundpan.svg" />
              </div>
              <div class="search-result-empty-text mt-4">No data found.</div>
            </div>
          </div>
        </b-overlay>
      </div>

      <div
        class="
          acs-paginaTion-new
          d-flex
          justify-content-between
          align-items-center
        "
      >
        <div class="d-flex">
          <span class="acs-gotopage-text p-1 mr-2">Go to page</span>
          <b-form-input
            v-model="goToPage"
            @keyup.enter="goToPages(goToPage)"
            @keypress="NumbersOnly"
            type="text"
            class="acs-pagination-num"
          ></b-form-input>
          <div
            class="acs-pagination-addbtn"
            @click="
              goToPage === null || goToPage == '' || !iscontainsNumber
                ? ''
                : goToPages(goToPage)
            "
            :disabled="goToPage === null || goToPage == '' || !iscontainsNumber"
          >
            <span
              :class="
                goToPage === null || goToPage == '' || !iscontainsNumber
                  ? 'disableDeleteIcon pl-3 mt-1'
                  : 'pointer pl-3 mt-1'
              "
            >
              <img src="../../../assets/panelist/page_arrow.svg" alt />
            </span>
          </div>
        </div>

        <div class="pagination">
          <b-pagination
            v-model="currentPage"
            @input="checkAndGetData(), (goToPage = null)"
            :total-rows="total"
            :per-page="pageCount"
            align="center"
            first-number
            last-number
          >
            <template #prev-text>
              <span>
                <img src="../../../assets/img/accessconnew/pageleft.svg" alt />
              </span>
            </template>
            <template #next-text>
              <span>
                <img src="../../../assets/img/accessconnew/pageright.svg" alt />
              </span>
            </template>
          </b-pagination>
        </div>
        <div class="d-flex align-items-center">
          <PageInput :pagecount="pageCount" @update-value="updatePage" />

          <div class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end">
            Showing :
            <div
              class="text-truncate ml-2 results-individual-width"
              v-if="pageStart > total"
            >
              0
            </div>
            <div class="text-truncate ml-2 results-individual-width" v-else>
              {{ pageStart }}
            </div>
            <div class="text-truncate results-individual-width">-</div>
            <div class="text-truncate results-individual-width">
              {{ pageEnd }}
            </div>
            <div class="text-truncate ml-1 results-individual-width">of</div>
            <div class="text-truncate ml-1 results-individual-width">
              {{ total }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bluebtn d-flex justify-content-end p-3">
      <b-button @click="closeModal()" class="acs-cancelBtn-modal pointer mr-3"
        >Cancel</b-button
      >
      <div class="position-relative bluebtn">
        <b-button
          :disabled="candidatesSelected.length == 0 || LoaderStatus"
          @click="triggerAssessment()"
          class="acs-addBtn-modal"
          :class="showSpinner ? 'upload-loader-class defaultCursor' : 'pointer'"
          >{{ showSpinner ? "" : "Trigger Assessment" }}</b-button
        >
        <div v-if="showSpinner" class="upload-loader-pos">
          <Loader />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Sourcemulti from "../../../components/fixedcomponents/TalentPool/Source.vue";
import toast from "../../mixin/toast";
import { NumbersOnly } from "../../../controllers/Candidate/helpers";
import { downloadResumeFile } from "../../../utils/download.js";
import {
  getVendorCandidates,
  triggerAssessment,
  getRoundDetails,
  getResume,
} from "../../../utils/apiFunctions";
import AddedByUsers from "../../../components/fixedcomponents/TalentPool/AddedByUsers.vue";
import PageInput from "../../../components/InputComponents/PaginationInput.vue";
import Loader from "../../../components/fixedcomponents/Loader.vue";
import { mapGetters } from "vuex";
export default {
  name: "TriggerMultipleAssessment",
  props: {
    showMultiTrigger: Boolean,
    process: Object,
    level: String,
    particularJob: Object,
    viewCandID: String,
  },
  mixins: [toast],
  data() {
    return {
      candidates: [],
      total: 0,
      showSpinner: false,
      showfiltercard: false,
      LoaderStatus: false,
      currentPage: 1,
      pageCount: 10,
      goToPage: null,
      pageStart: "",
      pageEnd: "",
      statusValue: "createdAt",
      sortByValue: false,
      sortOrder: -1,
      searchQuery: "",
      isSelectedAll: false,
      allSelected: false,
      applyflag: false,
      filtercount: 0,
      candidatesSelected: [],
      storeFilterSource: [],
      storeFilterSkills: [],
      storeFilterAddedBY: [],
      storenoOfTriggers: "",
      vendor: false,
      filterObject: {
        noOfTriggers: "",
        filterSource: [],
        skillSets: [],
        createdByUserName: [],
      },
    };
  },
  components: {
    PageInput,
    Sourcemulti,
    AddedByUsers,
    Loader,
  },
  created() {
    this.vendor = this.$route.name == "VendorKanban" ? true : false;
    this.checkAndGetData();
  },
  computed: {
    showThirdParty() {
      return !this.vendor && this.checkThirdPartyAccess;
    },
    disableApplyFilter() {
      return (
        this.filterObject.noOfTriggers ||
        this.filterObject.skillSets.length !== 0 ||
        this.filterObject.filterSource.length !== 0 ||
        this.filterObject.createdByUserName.length !== 0
      );
    },
    totalPages() {
      return Math.ceil(this.total / this.pageCount);
    },
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    formattedSelectedLength() {
      return this.candidatesSelected.length < 10
        ? "0" + this.candidatesSelected.length
        : this.candidatesSelected.length;
    },
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
    ...mapGetters("userVUEX", {
      thirdPartyData: "getThirdPartyData",
    }),
    checkThirdPartyAccess() {
      let val = this.thirdPartyData.data.find(
        (obj) => obj.thirdPartyID === "hire3xcvsearch"
      );
      if (!val) {
        return false;
      }
      return val.enabled;
    },
  },
  methods: {
    async downloadResume(data) {
      try {
        this.LoaderStatus = true;
        let payload = {
          candidateID: data.candidateID,
        };
        const res = await getResume(payload);
        if (res.status == 200) {
          const link = res.data.data.resumeLink;
          // implemented bcz once we click on download resume that page shouldn't go blank
          const candidateName = res.data.data.name;

          await downloadResumeFile(link, candidateName);
          this.LoaderStatus = false;
          this.successModal("Resume downloaded successfully");
        } else if (res.status == 409) {
          this.errorModal(res.data.data.Detail);
        }
        this.LoaderStatus = false;
      } catch (error) {
        this.LoaderStatus = false;
        console.error(error);
      }
    },
    checkAndGetData() {
      this.sortOrder = this.sortByValue ? 1 : -1;
      this.applyflag = true;
      this.LoaderStatus = true;
      if (this.vendor) {
        this.getcandidateVendorJd();
      } else {
        this.getCandidates();
      }
    },
    applyFilterTest() {
      this.filtercount = 0;
      this.showfiltercard = false;
      this.checkAndGetData();
      this.storeFilterSource = this.filterObject.filterSource;
      this.storenoOfTriggers = this.filterObject.noOfTriggers;
      this.storeFilterSkills = this.filterObject.skillSets;
      this.storeFilterAddedBY = this.filterObject.createdByUserName;
    },
    cancelFilter() {
      this.filterObject.filterSource = this.storeFilterSource;
      this.filterObject.noOfTriggers = this.storenoOfTriggers;
      this.filterObject.skillSets = this.storeFilterSkills;
      this.filterObject.createdByUserName = this.storeFilterAddedBY;
      this.showfiltercard = false;
    },
    hideFilterBox() {
      this.showfiltercard = false;
    },
    clearfilter(flag) {
      this.applyflag = flag;
      this.filtercount = 0;
      this.filterObject = {
        noOfTriggers: "",
        filterSource: [],
        skillSets: [],
        createdByUserName: [],
      };
      if (this.applyflag) {
        this.showfiltercard = false;
        this.LoaderStatus = true;
        this.currentPage = 1;
        this.storeFilterSource = [];
        this.storenoOfTriggers = "";
        this.storeFilterSkills = [];
        this.storeFilterAddedBY = [];
        this.checkAndGetData();
      }
      this.applyflag = false;
    },
    showFilter() {
      if (this.showfiltercard) {
        this.showfiltercard = false;
      } else {
        this.filterObject.filterSource = this.storeFilterSource;
        this.filterObject.noOfTriggers = this.storenoOfTriggers;
        this.filterObject.skillSets = this.storeFilterSkills;
        this.filterObject.createdByUserName = this.storeFilterAddedBY;
        this.showfiltercard = true;
      }
    },
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.checkAndGetData();
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    convertToLowerCase(data) {
      return data.toLowerCase();
    },
    async triggerAssessment() {
      this.showSpinner = true;
      try {
        let payload = {
          panelList: [],
          candidateID: [],
          jobID: "",
          customerID: "",
          level: {},
        };
        for (const i of this.candidatesSelected) {
          payload.candidateID.push(i);
          payload.level[i] = this.process.id;
        }
        if (this.vendor) {
          payload.vendorID = this.$route.params.vendorID;
        }
        payload.customerID = this.particularJob.customerID;
        payload.jobID = this.particularJob.jobID;
        let panel = "cvinfra@simplify3x.com";
        payload.panelList.push(panel);
        const res = await triggerAssessment(payload);
        if (res.status == 200) {
          this.$emit("trigger-success");
          this.closeModal();
          this.$nextTick(() => {
            this.dynamicToast(
              "triggered",
              "Successfully triggered",
              "Assessment has been triggered to selected candidates"
            );
          });
        } else {
          this.errorModal("Something went wrong");
        }
        this.showSpinner = false;
      } catch (error) {
        this.errorModal("Something went wrong");
        this.showSpinner = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    goToPages(index) {
      this.currentPage = Math.min(Math.max(1, index), this.totalPages);
      this.goToPage = null;
      this.checkAndGetData();
    },
    selectAllCandidates() {
      if (this.allSelected) {
        let val;
        for (let cand of this.candidates) {
          if (
            !this.candidatesSelected.includes(cand.candidateID) &&
            this.candidatesSelected.length < 20
          ) {
            this.candidatesSelected.push(cand.candidateID);
          }
          if (
            this.candidatesSelected.length == 20 &&
            !this.candidatesSelected.includes(cand.candidateID)
          ) {
            val = true;
          }
        }
        if (val)
          this.errorModal("Cannot select more than 20 candidates at once!");
      } else {
        for (let cand of this.candidates) {
          const index = this.candidatesSelected.indexOf(cand.candidateID);
          if (index !== -1) {
            this.candidatesSelected.splice(index, 1);
          }
        }
      }
      this.deselect();
    },
    deselect() {
      this.allSelected = false;
      const containsAll = this.candidates.every((element) => {
        return this.candidatesSelected.includes(element.candidateID);
      });
      if (containsAll) {
        this.allSelected = true;
      }
      this.checkForDisabledSelect();
      if (this.candidatesSelected.length == 20) {
        this.errorModal("Cannot select more than 20 candidates at once!");
      }
    },
    closeModal() {
      this.$emit("close-multi-trigger");
    },
    checkSelectAll() {
      let isSelectedAll = true;
      if (this.candidates.length !== 0) {
        for (let record of this.candidates) {
          if (
            (this.candidatesSelected.filter(
              (value) => value == record.candidateID
            ).length === 0 &&
              record.active) ||
            record.active == null
          ) {
            isSelectedAll = false;
            break;
          }
        }
      } else {
        isSelectedAll = false;
      }
      this.allSelected = isSelectedAll;
      this.checkForDisabledSelect();
    },
    checkForDisabledSelect() {
      this.candidates.map((obj) => {
        if (
          !this.candidatesSelected.includes(obj.candidateID) &&
          this.candidatesSelected.length == 20
        ) {
          obj.disabled = true;
        }
      });
      let values = this.candidates.filter((obj) => {
        if (!obj.disabled) {
          return obj;
        }
      });
      if (values.length === 0) {
        this.allSelected = false;
      } else {
        const containsAll = values.every((element) => {
          return this.candidatesSelected.includes(element.candidateID);
        });
        this.allSelected = containsAll;
      }
    },
    async getCandidates() {
      let payload = {
        page: this.currentPage - 1,
        count: this.pageCount,
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
        sortBy: {
          column: this.statusValue,
          order: this.sortOrder,
        },
        level: this.level,
        filters: {
          skillSets: this.filterObject.skillSets,
          source: this.filterObject.filterSource,
          assessment_state: "",
          addedBy: this.filterObject.createdByUserName,
          noOfTriggers: this.filterObject.noOfTriggers,
        },
        searchQuery: this.searchQuery,
        userType: this.customerDetail.lead ? "Lead Recruiter" : "Recruiter",
        rejectedByAI: false,
      };
      this.filtercount = 0;
      if (this.disableApplyFilter) {
        this.filtercount++;
      }
      const res = await getRoundDetails(payload);
      if (res.status == 200) {
        this.candidates = res.data.data.data;
        this.pageStart = res.data.data.pageStart;
        this.pageEnd = res.data.data.pageEnd;
        this.total = res.data.data.total;
        this.candidates.map((obj) => (obj.disabled = false));
        this.checkSelectAll();
      }
      this.LoaderStatus = false;
    },
    async getcandidateVendorJd() {
      let payload = {
        page: this.currentPage - 1,
        count: this.pageCount,
        jobID: this.particularJob.jobID,
        customerID: this.particularJob.customerID,
        vendorID: this.$route.params.vendorID,
        sortBy: {
          column: this.statusValue,
          order: this.sortOrder,
        },
        level: this.level,
        filters: {
          skillSets: this.filterObject.skillSets,
          source: this.filterObject.filterSource,
          addedBy: this.filterObject.createdByUserName,
          noOfTriggers: this.filterObject.noOfTriggers,
        },
        searchQuery: this.searchQuery,
      };
      this.filtercount = 0;
      if (this.disableApplyFilter) {
        this.filtercount++;
      }
      try {
        const res = await getVendorCandidates(payload);
        if (res.status == 200) {
          this.candidates = res.data.data.data;
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.total = res.data.data.total;
          this.candidates.map((obj) => (obj.disabled = false));
          this.checkSelectAll();
        }
        this.LoaderStatus = false;
      } catch (err) {
        this.LoaderStatus = false;
        console.error(err);
      }
    },
  },
};
</script>

<style scoped>
.upload-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 179px;
}

.upload-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 44px;
}

.kanban-exc-table-row {
  width: 100%;
  position: relative;
  border-radius: 5px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  padding: 10px 0;
  /* margin: 8px 0px; */
}

.kanban-exc-table-row:hover {
  background: #e7e8f5;
}
</style>
